import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  [
    'inline-flex items-center gap-1.5',
    'border rounded-[3px]',
    'px-2 py-0.5',
    'font-mono text-[10px] font-medium uppercase',
    'tracking-[0.06em]',
  ].join(' '),
  {
    variants: {
      tone: {
        neutral: 'bg-card border-line-strong text-ink-2',
        amber: 'bg-warning/10 border-warning/40 text-warning',
        green: 'bg-success/10 border-success/40 text-success',
        red: 'bg-destructive/10 border-destructive/40 text-destructive',
        blue: 'bg-icaria-100 border-icaria-200 text-icaria-700',
      },
      dot: {
        true: "before:content-[''] before:w-1.5 before:h-1.5 before:rounded-full before:bg-current",
        false: '',
      },
    },
    defaultVariants: { tone: 'neutral', dot: false },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, tone, dot, ...props }: BadgeProps) => (
  <span className={cn(badgeVariants({ tone, dot }), className)} {...props} />
);

export { Badge };
